import { DeleteOutlineRounded, EditOutlined, MoreVert, ReorderRounded } from '@mui/icons-material';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import React, { useCallback, useState } from 'react';

import { CollectionWithCreator } from '../../../../Types/dealGPT';
import { useAuth } from '../../../Providers/AuthProvider';

interface CollectionContextMenuProps {
  collection: CollectionWithCreator;
  setShowDeleteConfirmationDialog: (val: boolean) => void;
  setEditingCollection: (val: boolean) => void;
  setReordering: (val: boolean) => void;
  setExpanded: (val: boolean) => void;
}

const CollectionContextMenu: React.FC<CollectionContextMenuProps> = ({
  collection,
  setShowDeleteConfirmationDialog,
  setEditingCollection,
  setReordering,
  setExpanded,
}) => {
  const { currentUser } = useAuth();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  }, []);

  return (
    <>
      <IconButton onClick={handleOpen} sx={{ width: '40px', height: '40px' }}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setExpanded(false);
            setEditingCollection(true);
          }}
          sx={{ marginBottom: 1 }}
        >
          <ListItemIcon>
            <Tooltip title="Edit this collection name, description or tags" arrow>
              <EditOutlined fontSize="small" />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary="Edit Collection" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setExpanded(true);
            setReordering(true);
          }}
          sx={{ marginBottom: 1 }}
        >
          <ListItemIcon>
            <Tooltip title="Reorder categories" arrow>
              <ReorderRounded fontSize="small" />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary="Reorder Categories" />
        </MenuItem>
        {collection.createdBy === currentUser?.id && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              setShowDeleteConfirmationDialog(true);
            }}
            sx={{ marginBottom: 1 }}
          >
            <ListItemIcon>
              <Tooltip title="Permanently delete this collection" arrow>
                <DeleteOutlineRounded color="error" fontSize="small" />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Delete Collection" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default CollectionContextMenu;
